import Axios from 'axios';
import { Config } from '../apiRoutes';
import { authHeaders } from '../headers';
import { getSessionToken } from '../../utils/sessionToken';

import {
  STORE_FIND_OR_CREATE_REQUESTED,
  STORE_FIND_OR_CREATE_SUCCESS,
  STORE_FIND_OR_CREATE_FAILURE,
  INSTALL_REQUESTED,
  INSTALL_SUCCESS,
  INSTALL_FAILURE,
} from '../types';

export const findOrCreateRequested = () => {
  return {
    type: STORE_FIND_OR_CREATE_REQUESTED
  }
};

export const findOrCreateSuccess = (store) => {
  return {
    type: STORE_FIND_OR_CREATE_SUCCESS,
    payload: store
  }
};

export const findOrCreateFailure = () => {
  return {
    type: STORE_FIND_OR_CREATE_FAILURE
  }
};

export const installRequested = () => {
  return {
    type: INSTALL_REQUESTED
  }
};

export const installSuccess = () => {
  return {
    type: INSTALL_SUCCESS
  }
};

export const installFailure = () => {
  return {
    type: INSTALL_FAILURE
  }
};

// POST /install is unauthenticated on the worker - it validates the
// session token itself, exchanges it for an offline token and registers
// webhooks. Called once per page load; the worker treats re-installs as
// a token refresh, so it's safe to repeat.
export const install = () => {
  return async (dispatch) => {
    dispatch(installRequested());

    try {
      const sessionToken = await getSessionToken();
      const endPoint = Config.baseUrl + Config.install;

      await Axios.post(endPoint, { session_token: sessionToken }, { headers: Config.headers });
      dispatch(installSuccess());
      return true;
    } catch {
      dispatch(installFailure());
      return false;
    }
  }
}

export const findOrCreate = () => {
  return async (dispatch) => {
    dispatch(findOrCreateRequested());

    const endPoint = Config.baseUrl + Config.store;
    const headers = await authHeaders();

    return Axios.post(endPoint, {}, { headers: headers })
      .then((response) => {
        dispatch(findOrCreateSuccess(response.data));
      })
      .catch(() => {
        dispatch(findOrCreateFailure());
      });
  }
}
